
import { defineComponent } from "vue";
export default defineComponent({
  name: "event-card-placeholder",
  props: ["admin"],
  methods: {},
});
